import { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import AbsenceSettings from './absenceSettings';
import AbsenceTypes from './absenceTypes';
import ParentalLeaves from './parentalLeaves';
import MedicalLeaves from './medicalLeaves';
import Others from './others';

const AbsenceSettingTabs = (props) => {
    const { t, handleUserDataChange, handleClientRuleChange } = props;
    const [absenceTypeKey, setAbsenceTypeKey] = useState(Date.now());
    const handClientDataChange = (name, value) => {
        handleClientRuleChange(name, value);
        setAbsenceTypeKey(Date.now());
    }
    return (
        <Tabs defaultActiveKey="absenceSettings" id="MainTabContainer">
            <Tab eventKey="absenceSettings" title={t('Absence Settings')}>
                <AbsenceSettings
                    handleUserDataChange={handleUserDataChange}
                    handleClientRuleChange={handClientDataChange} />
            </Tab>
            <Tab eventKey="absenceTypes" title={t('Absence Types')}>
                <AbsenceTypes key={absenceTypeKey} />
            </Tab>
            <Tab eventKey="parentalLeaves" title={t('Parental Leave')}>
                <ParentalLeaves
                    handleUserDataChange={handleUserDataChange} />
            </Tab>
            <Tab eventKey="medicalLeaves" title={t('Medical Leave')}>
                <MedicalLeaves
                    handleUserDataChange={handleUserDataChange} />
            </Tab>
            <Tab eventKey="others" title={t('Others')}>
                <Others
                    handleUserDataChange={handleUserDataChange}
                    handleClientRuleChange={handClientDataChange} />
            </Tab>
        </Tabs>
    )
}

export default withLocalization(AbsenceSettingTabs);